import clsx from "clsx";
import type { ComponentProps } from "react";

import { CardInfo } from "@features/card-info";

import { Body, Heading } from "@shared/ui/typography";

import type { CardInfoType } from "../model";

import s from "./home-more-about.module.scss";

export type HomeMoreAboutProps = ComponentProps<"div"> & {
  className?: string;
  title: string;
  description?: string;
  cards: CardInfoType[];
};

export const HomeMoreAbout = (props: HomeMoreAboutProps) => {
  const { className, cards, title, description } = props;

  return (
    <div className={clsx(s.root, className)}>
      <div className={s.info}>
        <div>
          <Body size="uppercase-small" weight="semiBold" className={s.subtitle}>
            еще о курорте
          </Body>
          <Heading level={3} tag="h2" className={s.title}>
            {title}
          </Heading>
        </div>
        {description && <Body>{description}</Body>}
      </div>
      <div className={s.cards}>
        {(cards ?? []).map((card, idx) =>
          card ? (
            <CardInfo
              key={card?.id ?? `card-${idx}`}
              className={s.card}
              card={card}
            />
          ) : null,
        )}
      </div>
    </div>
  );
};

HomeMoreAbout.displayName = "HomeMoreAbout";
